import React from 'react';
import { MapPin } from 'lucide-react';
export const LocationRibbon = () => {
  return <div className="w-full bg-be-pink text-white py-2.5 flex justify-center items-center gap-2 px-4 text-center z-20 relative" data-id="element-175">
      <MapPin size={16} className="shrink-0" data-id="element-176" />
      <span className="text-xs sm:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-177">
        3130 Crow Canyon Pl, Suite 180 · San Ramon, CA 94583
      </span>
    </div>;
};